import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {DialogLookupUsersGroupsComponent} from '../../../../../shared/components/dialog-lookup-users-groups/dialog-lookup-users-groups.component';
import {API_URLS} from '../../../../../../../environments/env-routes';
import {APIHelper} from '../../../../../../../shared/services/api-helper/api-helper.service';
import {DialogLookupPermissionsComponent} from '../dialog-lookup-permissions/dialog-lookup-permissions.component';
import { GroupNames } from 'src/app/users/+users/see-users/shared/pipes/groupNames.pipe';

@Component({
  selector: 'app-dialog-see-file-permissions',
  templateUrl: './dialog-see-file-permissions.component.html',
  styleUrls: ['./dialog-see-file-permissions.component.scss'],
  providers:[GroupNames]

})
export class DialogSeeFilePermissionsComponent implements OnInit {
  public loading: boolean;
  public inheritedPermissions: any[];
  public permissions: any[];
  public isInherited: boolean;

  constructor(
    private api: APIHelper,
    public dialogRef: MatDialogRef<DialogLookupUsersGroupsComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.inheritedPermissions = [];
    this.permissions = [];
    this.initialize();
  }

  initialize() {
    if (!this.data.idFile) {
      this.dialogRef.close();
    }

    this.requestPermission({ id: this.data.idFile });
  }

  openPermissions() {
    const dialogRef = this.dialog.open(DialogLookupPermissionsComponent, {
      width: '40%',
      height: '40%',
      data:{}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.length) {
        return;
      }

      // locallySet doit être renvoyé entièrement à chaque fois pour une raison qui m'échappe !
      // Alfresco écrasera à chaque fois tous les précédents droits pour appliquer ceux du nouveau locallySet
      // DOnc on a interêt à ne pas oublier de rajouter les précédente permissions
      // On le prérempli donc
      const datasArr = [...this.permissions];
      for (const el of result) {
        const obj = {
          authorityId: null,
          name: el.role,
          accessStatus: 'ALLOWED'
        };

        if (el.nodeType === 'cm:person') {
          obj.authorityId = el.properties['cm:userName'];
        } else if (el.nodeType === 'cm:authorityContainer') {
          obj.authorityId = el.properties['cm:authorityName'];
        }

        const indexIfAdded = this.hasAlreadyBeenAdded(obj, this.permissions);
        // Alfresco plante si on ajoute une permission qui a déjà été envoyé précédemment,
        // donc il faut modifier celle qui a déjà été ajoutée
        if (indexIfAdded === -1) {
          datasArr.push(obj);
        } else {
          this.permissions[indexIfAdded].accessStatus = 'ALLOWED';
        }
      }

      const datas = {
        permissions: {
          locallySet: datasArr
        }
      };

      this.requestPermission({
        id: this.data.idFile,
        dataToSend: datas,
        type: 'PUT'
      });
    });
  }

  changeHerit(value) {
    const data = { permissions: { isInheritanceEnabled: value.checked } };

    this.requestPermission({
      id: this.data.idFile,
      dataToSend: data,
      type: 'PUT'
    });
  }

  removePermission(permission: any) {
    this.permissions.forEach(el => {
      if (el.authorityId === permission.authorityId) {
        el.accessStatus = 'DENIED';
      }
    });

    const data = {
      permissions: {
        locallySet: [...this.permissions]
      }
    };
    this.requestPermission({
      id: this.data.idFile,
      dataToSend: data,
      type: 'PUT'
    });
  }

  requestPermission({
    id,
    dataToSend = null,
    type = 'GET'
  }: {
    id: string;
    dataToSend?: any;
    type?: string;
  }) {
    this.loading = true;
    const queries = 'include=path,properties,allowableOperations,permissions';

    const methodChosen = type;
    const data = dataToSend || null;

    return this.api
      .requestApi({
        action: API_URLS.nodes.nodes.replace(':nodeId', id),
        queryArgs: queries,
        method: methodChosen,
        datas: data
      })
      .then(res => {
        this.loading = false;
        this.inheritedPermissions = res.permissions.inherited || [];
        this.permissions = res.permissions.locallySet || [];
        this.isInherited = res.permissions.isInheritanceEnabled;

        if (this.permissions.length) {
          this.permissions = this.permissions.filter(
            p => p.accessStatus !== 'DENIED'
          );
        }
      });
  }

  public hasAlreadyBeenAdded(el, arr) {
    let i = 0;
    for (const r of arr) {
      if (r.authorityId === el.authorityId) {
        return i;
      }

      i++;
    }

    return -1;
  }
}
